import { Phone } from 'lucide-react';
import { ContactCard } from '../cards/ContactCard';
import { SectionHeader, EmptyState } from '../shared/InfoGrid';
import type { Contact, Traveler } from '../utils/types';

interface ContactsTabProps {
  contacts: Contact[];
  travelers: Traveler[];
}

export function ContactsTab({ contacts, travelers }: ContactsTabProps) {
  if (!contacts || contacts.length === 0) {
    return (
      <EmptyState
        icon={<Phone className="h-6 w-6" />}
        title="No contacts"
        description="This booking doesn't contain any contact information"
      />
    );
  }

  // Separate emails and phones
  const emails = contacts.filter(c => c.contactType === 'Email');
  const phones = contacts.filter(c => c.contactType === 'Phone');

  return (
    <div>
      <SectionHeader
        title="Contacts"
        icon={<Phone className="h-5 w-5" />}
        count={contacts.length}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {contacts.map(contact => (
          <ContactCard
            key={contact.id}
            contact={contact}
            travelers={travelers}
          />
        ))}
      </div>
    </div>
  );
}
